import './App.css';
import QRReader from './QReader.jsx';

function App() {
  return (
    <div className="App">
      <QRReader />
    </div>
  );
}

export default App;
